// Public, unauthenticated endpoints of a segproxy miner's dashboard (segments-pool PublicMinerController)

export interface HashPoint {
    timeStamp: number;
    hash: number | null;
}

export interface ChartPoint {
    time: string;
    hashrate: number;
}

export const minerApiPath = (address: string): string =>
    `/pool/public/segproxy/${encodeURIComponent(address)}`;

export const toChartData = (points: HashPoint[] | null | undefined): ChartPoint[] =>
    (points ?? []).map(point => ({
        time: new Date(point.timeStamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
        hashrate: Number((point.hash ?? 0).toFixed(1)),
    }));

export const formatCoinAmount = (value: number | null | undefined): string =>
    value == null ? '-' : value.toFixed(8);
